function SalesOrderToolbar({ activeView, onChangeView }) {
  return (
    <div className="inline-flex w-fit max-w-full flex-wrap gap-1 rounded-[18px] border border-[var(--theme-border)] bg-[var(--theme-accent-soft)] p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.68)]">
      <ToolbarButton
        label="Sales Order List"
        isActive={activeView === 'list'}
        onClick={() => onChangeView('list')}
      />
      <ToolbarButton
        label="Add Sales Order"
        isActive={activeView === 'create'}
        onClick={() => onChangeView('create')}
      />
    </div>
  );
}

function ToolbarButton({ label, isActive, onClick }) {
  return (
    <button
      className={`inline-flex min-h-[44px] items-center justify-center rounded-[14px] px-5 text-[0.94rem] font-semibold outline-none transition focus-visible:ring-2 focus-visible:ring-[var(--theme-focus)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--theme-app-bg)] sm:px-6 ${
        isActive
          ? 'bg-white text-[var(--theme-text)] shadow-[0_10px_22px_rgba(var(--theme-shadow-rgb),0.12)] ring-1 ring-[var(--theme-accent)]'
          : 'text-[var(--theme-accent-strong)] hover:bg-white/65 hover:text-[var(--theme-text-strong)]'
      }`}
      type="button"
      onClick={onClick}
      aria-pressed={isActive}
    >
      {label}
    </button>
  );
}

export default SalesOrderToolbar;
